export const features = [
    {
      icon: "M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z",
      title: "Premium Quality",
      description: "Our scrubs are made from high-quality, durable fabrics that maintain their shape and color after multiple washes."
    },
    {
      icon: "M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z",
      title: "All-Day Comfort",
      description: "Breathable, moisture-wicking fabrics designed for long shifts and active movement. Feel great all day long."
    },
    {
      icon: "M7 21a4 4 0 01-4-4V5a2 2 0 012-2h4a2 2 0 012 2v12a4 4 0 01-4 4zm0 0h12a2 2 0 002-2v-4a2 2 0 00-2-2h-2.343M11 7.343l1.657-1.657a2 2 0 012.828 0l2.829 2.829a2 2 0 010 2.828l-8.486 8.485M7 17h.01",
      title: "Stylish Designs",
      description: "Modern fits and colors that help you look professional while expressing your personal style."
    }
  ];